<template>
	<div>
		<topbar>
			<template
				slot="title"
			>
				<slot name="title" />
			</template>

			<template
				slot="head-right"
				slot-scope="item"
			>
				<slot
					name="head-right"
					v-bind="item"
				/>
			</template>

			<template
				slot="head-left"
				slot-scope="item"
			>
				<slot
					name="head-left"
					v-bind="item"
				/>
			</template>
		</topbar>

		<div
			v-if="!mobile"
			class="card"
		>
			<div class="card-body p-0">
				<div
					class="table-responsive"
					:class="[$style['table-responsive'], !bordered ? $style['table-clean'] : '']"
				>
					<table
						class="table table-hover table-striped"
						:class="$style.table"
					>
						<thead>
							<tr>
								<th
									:class="[$style.th,$style.thCheck]"
									class="text-center"
								>
									<a-checkbox
										:indeterminate="checkedSome"
										:checked="checkedAll"
										@change="checkAll($event.target.checked)"
									/>
								</th>
								<th
									v-for="(col, i) in cols"
									:key="i"
									:class="$style.th"
									:style="{'text-align': (col.align || 'left'), 'min-width':(col.width || 'auto')}"
								>
									<order-filter
										v-if="col.order"
										:title="col.title"
										:index="col.index"
										:view="view"
									/>
									<template v-else>
										{{ col.title || col.index || '???' }}
									</template>

									<select-filter
										v-if="col.filters"
										:index="col.index"
										:filters="col.filters"
										:view="view"
									/>

									<search-filter
										v-if="col.search"
										:index="col.index"
										:view="view"
									/>
								</th>
							</tr>
						</thead>

						<tbody>
							<tr
								v-for="(colData, colDataIndex) in data.results"
								:key="colDataIndex"
							>
								<td
									class="text-center"
									:class="$style.td"
								>
									<a-checkbox
										:checked="checked[colDataIndex]"
										@change="check(colDataIndex, $event.target.checked)"
									/>
								</td>
								<td
									v-for="(col, colIndex) in cols"
									:key="colIndex"
									:class="$style.td"
									:align="col.align || 'left'"
								>
									<slot
										v-if="col.slot==='_actions'"
										name="_actions"
										v-bind="colData"
									>
										<slot-action
											:item="colData"
											:app="app"
											@edit="$emit('edit', $event)"
										/>
									</slot>

									<slot
										v-else-if="col.slot==='_email'"
										name="_email"
										v-bind="colData"
									>
										<slot-email :item="colData[col.index]" />
									</slot>

									<slot
										v-else-if="col.slot==='_date'"
										name="_date"
										v-bind="colData"
									>
										<slot-date :item="colData[col.index]" />
									</slot>

									<slot
										v-else-if="col.slot==='_datetime'"
										name="_datetime"
										v-bind="colData"
									>
										<slot-datetime :item="colData[col.index]" />
									</slot>

									<slot
										v-else-if="col.slot==='_time'"
										name="_time"
										v-bind="colData"
									>
										<slot-time :item="colData[col.index]" />
									</slot>

									<slot
										v-else-if="col.slot==='_select'"
										name="_select"
										v-bind="colData"
									>
										<slot-select
											:item="colData[col.index]"
											:index="col.index"
											:app="app"
										/>
									</slot>

									<slot
										v-else-if="col.slot==='_user'"
										name="_user"
										v-bind="colData"
									>
										<slot-user :item="colData[col.index]" />
									</slot>

									<slot
										v-else-if="col.slot!==undefined"
										:name="col.slot"
										v-bind="colData"
									>
										{{ colData[col.index] }}
									</slot>

									<div v-else>
										{{ colData[col.index] }}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<cards v-else>
			<template
				v-for="(col) in cols"
				:slot="col.slot"
				slot-scope="item"
			>
				<slot
					:name="col.slot"
					v-bind="item"
				/>
			</template>

			<template
				slot="_mobile"
				slot-scope="item"
			>
				<slot
					name="_mobile"
					v-bind="item"
				/>
			</template>
		</cards>

		<pagination />
	</div>
</template>

<script>
import topbar from './widgets/topbar';
import pagination from './widgets/pagination';
import cards from './widgets/cards';

import slotAction from './slots/actions';
import slotEmail from './slots/email';
import slotDate from './slots/date';
import slotDatetime from './slots/datetime';
import slotTime from './slots/time';
import slotUser from './slots/user';
import slotSelect from './slots/select';

import searchFilter from './filters/search';
import orderFilter from './filters/order';
import selectFilter from './filters/select';

export default {
	name: 'GTableSync',
	components: {
		topbar,
		pagination,
		cards,
		slotAction,
		slotEmail,
		slotDate,
		slotDatetime,
		slotTime,
		slotUser,
		slotSelect,
		searchFilter,
		orderFilter,
		selectFilter
	},
	props: {
		// Show header bar
		header: {
			type: Boolean,
			default: true
		},
		// Hide delete button
		hideDelete: {
			type: Boolean,
			default: false
		},
		// Hide refresh button
		hideRefresh: {
			type: Boolean,
			default: false
		},
		// Hide global search
		hideSearch: {
			type: Boolean,
			default: false
		},
		/// ///////////////////////
		// TABLE
		/// ///////////////////////
		bordered: {
			type: Boolean,
			default: false
		},

		/// ///////////////////////
		// QUERIES
		/// ///////////////////////

		mode: {
			type: String,
			default: 'table'
		},
		pagination: {
			type: String,
			default: 'default'
		},
		defaultSearch: {
			type: String,
			default: null
		},
		defaultOrder: {
			type: Object,
			default: null
		},
		defaultFilters: {
			type: Array,
			default: null
		},
		defaultLimit: {
			type: Number,
			default: null
		},
		/// ///////////////////////
		// DATA
		/// ///////////////////////

		// Columns
		columns: {
			type: Array,
			required: true
		},
		// App item
		app: {
			type: String,
			required: true
		},
		// View
		view: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			select: [],
			loading: false,
			end: false,
			page: 1,
			maxPage: 1,
			search: ''
		};
	},
	computed: {
		mobile() {
			if (this.$settings.isMobileView || this.$settings.isTabletView) return true;
			return false;
		},
		data() {
			const results = this.$gestios.$cache.view(this.view);
			if (results) return results;
			return {
				total: 0,
				results: []
			};
		},
		sync() {
			return this.$gestios.$cache.app(this.app).data();
		},
		cols() {
			return this.columns.map((col) => {
				if (col.index !== undefined && this.sync) {
					const field = this.sync.Fields[col.index] ? this.sync.Fields[col.index] : false;

					if (field) {
						if (col.title === undefined) {
							col.title = field.Placeholder;
						}

						if (col.search === undefined) {
							col.search = field.Searchable;
						}

						if (col.slot === undefined) {
							col.slot = `_${field.Type.toLowerCase()}`;
						}

						if (col.filters === undefined && field.Type === 'select') {
							const vars = JSON.parse(field.Vars);

							const filters = [];
							for (let i = 0; i < vars.length; i += 1) {
								const opt = vars[i];

								filters.push({
									text: opt.name,
									value: opt.id
								});
							}

							col.filters = filters;
						}
					}
				}

				col.oficial = false;
				if (col.slot && col.slot.substring(0, 1) === '_') col.oficial = true;

				if (col.slot === '_actions' && col.align === undefined) col.align = 'right';

				return col;
			});
		},
		checked() {
			return this.data.results.map((i) => {
				const find = this.select.findIndex((si) => si._EntityId === i._EntityId);
				if (find > -1) return true;
				return false;
			});
		},
		checkedAll() {
			return (this.select.length === this.data.results.length && this.select.length > 0);
		},
		checkedSome() {
			return !!this.select.length && this.select.length < this.data.results.length;
		},
		/// ///////////////////////
		// QUERIES
		/// ///////////////////////
		query() {
			return this.$query(this.view);
		},
		gFilter() {
			if (this.query.filters) return this.query.filters;
			return null;
		},
		gOrder() {
			if (this.query.orders) return this.query.orders;
			return null;
		},
		gLimit() {
			if (this.query.limit) return this.query.limit;
			return 12;
		},
		gMode() {
			if (this.mode) return this.mode;
			return 'table';
		},
		gPagination() {
			if (this.pagination === 'default' || this.pagination === 'infinite' || this.pagination === 'loadmore') return this.pagination;

			return 'default';
		},
		filtered() {
			if (this.gFilter || this.gOrder) return true;
			return false;
		}
	},
	watch: {
		defaultSearch(val) {
			this.setQuerySearch(val);
			this.reset();
		},
		defaultLimit(val) {
			this.setQueryLimit(val);
			this.reset();
		},
		defaultOrder(val) {
			this.setQueryOrder(val);
			this.reset();
		},
		defaultFilters(val) {
			this.setQueryFilter(val);
			this.reset();
		},
		'query.search': function () {
			this.reset();
		},
		'query.limit': function () {
			this.reset();
		},
		'query.orders': {
			deep: true,
			handler(newVal, oldVal) {
				if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
					this.reset();
				}
			}
		},
		'query.filters': {
			deep: true,
			handler(newVal, oldVal) {
				if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
					this.reset();
				}
			}
		}
	},
	created() {
		if (this.defaultOrder || this.defaultOrder === null) this.setQueryOrder(this.defaultOrder);
		if (this.defaultLimit && this.defaultLimit > 0) this.setQueryLimit(this.defaultLimit);
		if (this.defaultFilters || this.defaultFilters === null) {
			this.setQueryFilter(this.defaultFilters);
		}
		if (this.defaultSearch !== undefined) this.setQuerySearch(this.defaultSearch);
	},
	mounted() {
		this.search = this.query.search;
		this.list(true);
	},
	methods: {
		/// //////////////////////////
		// LIST & PAGINATION
		/// //////////////////////////
		reset() {
			this.page = 1;
			this.checkAll(false);
			this.list(true);
		},
		async list(reset = null) {
			this.loading = true;
			this.end = false;

			if (this.gPagination === 'default' && reset === null) reset = true;

			const result = await this.$gestios.items(this.app).list({
				view: this.view,
				limit: this.gLimit,
				page: this.page,
				filters: this.gFilter,
				order: this.gOrder,
				reset
			});

			if (result.code === 404) {
				if (this.page > 1) this.page -= 1;
				this.maxPage = this.page;
				this.end = true;
			} else if (result.ok) {
				this.maxPage = Math.ceil(parseInt(this.data.total, 10) / parseInt(this.gLimit, 10));
			}

			this.loading = false;
		},
		next() {
			this.page += 1;
			this.list();
		},
		back() {
			this.page -= 1;
			this.list();
		},
		cleanFilters() {
			this.query.filter.reset();
			this.query.order.reset();
			this.search = '';
		},
		/// //////////////////////////
		// ORDER & FILTERS
		/// //////////////////////////
		setQueryOrder(val) {
			this.query.order.delete(this.index);

			if (val) {
				Object.keys(val).forEach((key) => {
					this.query.order.add({ field: key, value: val[key] });
				});
			}
		},
		setQueryFilter(val) {
			this.$query(this.view).filter.delete({
				view: this.view
			});

			if (val) {
				val.forEach((f) => {
					this.$query(this.view).filter.add({
						view: this.view,
						field: f.field,
						type: f.type,
						value: f.value || null,
						from: f.from || null,
						lig: f.lig || null,
						to: f.to || null
					});
				});
			}
		},
		setQuerySearch(val) {
			this.query.search = val;
		},
		setQueryLimit(val) {
			this.query.limit = val;
		},
		/// //////////////////////////
		// CHECK
		/// //////////////////////////
		uncheck(item) {
			const index = this.select.findIndex((si) => item._EntityId === si._EntityId);
			if (index > -1) {
				this.select.splice(index, 1);
			}
		},
		check(index, val) {
			const item = this.data.results[index];
			const find = this.select.findIndex((si) => item._EntityId === si._EntityId);

			if (val && find === -1) {
				this.select.push(item);
			} else {
				this.uncheck(item);
			}
		},
		checkAll(val) {
			if (val) {
				this.select = this.data.results;
			} else {
				this.select = [];
			}
		},

		/// //////////////////////////
		// ITEM ACTIONS
		/// //////////////////////////
		deleteItems(items) {
			let errors = 0;
			items.forEach(async (item) => {
				const result = await this.$gestios.items(this.app).delete({ id: item._EntityId });
				if (!result.ok) {
					errors += 1;
				} else {
					this.uncheck(item);
				}
			});

			if (errors === 0) this.$message.success('Elementos borrados correctamente');
		}
	}
};
</script>

<style lang="scss" module>
	.table-responsive{
		border: 0;
		border-radius:6px;
		background: white;
		margin: 0;
	}

	.table{
		.th{
			text-transform: uppercase;
			font-family: Rubik;
			font-weight: 500;
			border-top: 0;
		}

		.thCheck{
			width: 50px;
		}

		.td{
			vertical-align: middle;
		}
	}

	.table-clean.table-responsive{
		border: 0;

		td,th{
			border: 0;
		}
	}
</style>
